Vendd.Scripts.load(function () {
    'use strict';
    var $wrapper = $('.x-wishlist-merchant'),
        wrapper;

    var model = null;

    if ($wrapper.length < 1)
        return;

    wrapper = $wrapper.get(0);

    wrapper.loading = function loading (loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        };
    };

    wrapper.update = function () {
        wrapper.loading(true);

        var html = Vendd.Handlebars.parse("wishlistMerchant", model);
        wrapper.bind(html);

        wrapper.loading(false);
    };

    wrapper.bind = function bind (html) {
        $wrapper.html(html);
    };

    $wrapper.on('click', '.js-remove', function (e) {
        var $this = $(this),
            $item = $this.closest('.wishlist-item');

        var id = $item.data('merchant-id');

        wrapper.loading(true);

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.WishlistMerchant.Messages.Remove(id));
    });

    $wrapper.on('click', '.js-remove-all', function (e) {
        wrapper.loading(true);

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.WishlistMerchant.Messages.Clear());
    });
    
    Vendd.MessageBus.subscribe(Vendd.WishlistMerchant.Messages.Changed, wrapper, function (envelope) {
        model = envelope.message.data;
        wrapper.update();
    });

    Vendd.MessageBus.subscribe(Vendd.WishlistMerchant.Messages.Failed, wrapper, function (envelope) {
        wrapper.loading(false);
    });

    Vendd.MessageBus.publishAsync(wrapper, new Vendd.WishlistMerchant.Messages.GetModel());
});